import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLDListElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLDListElement
 */
export default class HTMLDListElement extends HTMLElement {}
